import ChildrenBirthdayValidator from '@/modules/search/ChildrenBirthdayValidator'
import Observer from '@/utils/observer'

const $ = require('jquery')
const moment = require('moment')

const { SELECTOR, BREAKPOINT } = require('./api')
const { EXPRESSIONS_DICTIONARY } = require('./dictionaries')
const queryString = require('./queryString')

// =========================================================================
// Forms WFFM
// =========================================================================
const FORMS = {
  helpers: {
    /**
     * @name updateQueryString
     * @param  {function} callback [description]
     * @return {function|Boolean}
     */
    updateQueryString (callback) {
      if (SELECTOR.MAIN_SEARCH.exists()) {
        return callback && callback()
      } else {
        return false
      }
    },

    /**
     * @name getRangeValues - Get prices from radio attribute of value by regex
     * @param  {string} val - range price, ex. 0:1000
     * @param  {string} rangePart - type range price, ex. 'From' or 'To'
     * @return {number}
     */
    getRangeValues (value, rangePart) {
      let _value
      if (typeof value === 'undefined') {
        return null
      }
      if (rangePart == 'From') {
        _value = value.match(/^\d+/i)[0]
      } else if (rangePart == 'To') {
        _value = value.match(/(\d+)(?!.*\d)/i)[0]
      }
      return _value
    },

    /**
     * @name setPriceRange - Set price range based on values from query string
     * @param {number} _PriceFrom - set Price From
     * @param {number} _PriceTo - set Price To
     */
    setPriceRange (_PriceFrom, _PriceTo, valuesPriceRange) {
      let valueRadio
      const arrPriceRange = []
      const $radioListPriceRange = $('.main-search .custom-select-price-person').find('.radio input[type="radio"]')
      const $csPricePersonElem = $('.custom-select-price-person')

      FORMS.helpers.csRadiosList.radioLabel('.form-group', $csPricePersonElem).find('input[type="radio"]').each(function() {
        $(this).attr('checked', false)
        if ($(this).hasClass('checked')) {
          $(this).removeClass('checked')
        }
      })

      $radioListPriceRange.each(function() {
        const thisValue = $(this).val()
        arrPriceRange.push({
          From: FORMS.helpers.getRangeValues(thisValue, 'From'),
          To: FORMS.helpers.getRangeValues(thisValue, 'To'),
        })
      })

      for (let i = 0, len = $radioListPriceRange.length; i < len; i++) {
        const valuePriceDropdown = {
          From: FORMS.helpers.getRangeValues(arrPriceRange[i].From, 'From'),
          To: FORMS.helpers.getRangeValues(arrPriceRange[i].To, 'To'),
        }
        const valuePriceCompareFrom = checkPriceRangeFrom(_PriceFrom, valuePriceDropdown.From, valuePriceDropdown.To)
        const valuePriceCompareTo = checkPriceRangeTo(_PriceTo, valuePriceDropdown.From, valuePriceDropdown.To)

        //Log.debug('valuePriceCompare:', valuePriceDropdown, valuePriceCompare_From, valuePriceCompare_To);
        if (valuePriceCompareFrom) {
          if (valuePriceCompareTo) {
            valueRadio = `${valuePriceDropdown.From}:${valuePriceDropdown.To}`
            $radioListPriceRange.filter(`[value="${valueRadio}"]`).addClass('checked').prop('checked')
            FORMS.helpers.csRadiosList.onChange($radioListPriceRange.filter(`[value="${valueRadio}"]`).next('label'), $('.custom-select-price-person .section-title'))

            return false
          }
        }
        if (i == len - 1) {
          valueRadio = '0:0'
          $radioListPriceRange.filter(`[value="${valueRadio}"]`).addClass('checked').prop('checked')
          FORMS.helpers.csRadiosList.onChange($radioListPriceRange.filter(`[value="${valueRadio}"]`).next('label'), $('.custom-select-price-person .section-title'))
        }
      }

      function checkPriceRangeFrom (x, min, max) {
        if (max == 0) {
          max = valuesPriceRange.max
        }
        const _min = Math.min(min, max)
        const _max = Math.max(min, max)
        x = parseInt(x)

        return _min >= x && x <= _max
      }

      function checkPriceRangeTo (x, min, max) {
        if (max == 0) {
          max = valuesPriceRange.max
        }
        const _min = Math.min(min, max)
        const _max = Math.max(min, max)
        x = parseInt(x)
        if (x == 0) {
          x = 50000
        }

        return x >= _min && x <= _max
      }

      return null
    },

    /**
         * @name csRadiosList - Functionalities for radio list
         * @method
         * @type {Object}
         */
    csRadiosList: {
      radioLabel (childElem, parentElem) {
        return $(childElem, parentElem).find('.radio')
      },
      onChange (_this, csTitle) {
        this.changeValueSectionTitle(_this, csTitle)
      },
      changeValueSectionTitle (_this, csTitle) {
        const radioText = $.trim(_this.text())
        const titleGetText = csTitle.text()
        csTitle.html(radioText)

        if (radioText !== titleGetText) {
          csTitle.prev('.section-label').fadeIn()
        }
      },
      hideSectionTitle (parentSel) {
        const sectionLabel = parentSel.find('.section-label')
        const getTxtSectionLabel = sectionLabel.text()

        sectionLabel.fadeOut()
        parentSel.find('.section-title').html($.trim(getTxtSectionLabel))
      },
      getValue (value) {
        log.debug(value)
        return value
      },
    },

    /**
     * @name csDropdownBuild - Build bootstrap dropdown
     * @param  {Object} elementsForWraping [description]
     * @return {[type]}                    [description]
     */
    csDropdownBuild (elementsForWraping) {
      const dropdownMenuWrap = '<div class="dropdown-menu" />'
      elementsForWraping.wrapAll(dropdownMenuWrap)
    },

    /**
     * @name csDropdownRun - Run bootstrap dropdown for built elements
     * @param  {Object} elemListener [description]
     * @return {[type]}              [description]
     */
    csDropdownRun (elemListener) {
      elemListener.on('click', function(e) {
        e.preventDefault()
        const $this = $(this)

        //$this.parent().css('position', 'relative');
        $this.attr('data-toggle', 'dropdown').addClass('dropdown-toggle')

        setTimeout(function() {
          $this.dropdown()
        }, 50)
      })
    },

    /**
     * Build fake label for fields
     *
     * @param {JQuery} elements to enrich with a section label
     */
    csFakeLabel (elements) {
      const elementHasSectionLabel = element => element.parentNode.querySelector('.section-label') !== null
      const createSectionLabel = text => $(`<span class="section-label">${text}</span>`)

      function addFakeSectionLabel () {
        if (!elementHasSectionLabel(this)) {
          createSectionLabel(this.innerText).insertBefore(this)
        }
      }

      elements.each(addFakeSectionLabel)
    },

    /**
     * ListMiniTags - List of mini tags for select country & Airports
     * @param  {Array} targets            [description]
     * @param  {Object} csItemSelector     [description]
     * @param  {String} noneSelectedText    [description]
     * @param  {String} queryStringKeyName [description]
     * @return {[type]}                    [description]
     */
    listMiniTags (targets, csItemSelector, queryStringKeyName) {
      //Log.debug(this.call);

      if (SELECTOR.MAIN_SEARCH_ADVANCED.exists()) {
        if (window.innerWidth > BREAKPOINT.TABLET) {
          const lengthItems = targets.length
          const _targets = []
          let itemSpan = null
          const listMiniTagsWrap = $(csItemSelector).find(' .list-mini-tags')

          if (lengthItems > 0) {
            if (!$(csItemSelector).find('.list-mini-tags').exists()) {
              $(csItemSelector).append('<div class="list-mini-tags" />')
            }

            $(csItemSelector).find('.list-mini-tags').empty()
            $.each($(csItemSelector).find('select option:selected'), function(i) {
              const thisVal = $(this).val()
              if (thisVal == targets[i]) {
                _targets.push($(this).text())
              }
            })

            $.each(targets, function(i) {
              itemSpan = $('<span/>').attr('role', 'button').text(_targets[i]).attr('data-val', targets[i])
              listMiniTagsWrap.append(itemSpan)

              itemSpan.on('click', function() {
                const itemText = $(this).attr('data-val')

                for (let i = 0; i < targets.length; i++) {
                  if (itemText == targets[i]) {
                    targets.splice(i, 1)
                    log.debug(targets)

                    if (targets.length == 0) {
                      listMiniTagsWrap.fadeOut(300, function() {
                        $(this).remove()
                      })
                      $(csItemSelector).find('.section-title').fadeOut(100)
                    }
                  }

                  queryString.Update(queryStringKeyName, targets)

                  $(csItemSelector).find('select').val(targets)
                  $(csItemSelector).find('select').selectpicker('render')

                  if (i == 0) {
                    listMiniTagsWrap.fadeOut(100)
                    queryString.Remove(queryStringKeyName)

                  } else {
                    listMiniTagsWrap.fadeIn(100)
                  }
                }

                $(this).fadeOut(300, function() {
                  $(this).remove()
                })

              })
            })

            listMiniTagsWrap.fadeIn(100)

          } else {
            listMiniTagsWrap.fadeOut(300, function() {
              $(this).remove()
            })
          }
        } else {
          return false
        }
      }
      return false
    },

  },
  customSelect: {
    /**
         * @name duration
         * @param  {parentSel} parentSel - set object selector in jQuery
         * @param  {Boolean} updateQueryString - if ture update query string
         * @param  {Function} callback - do anything on change value radio input
         * @return undefined
         */
    duration (parentSel, updateQueryString, callback) {
      // -------------------------------------------------
      // Update queryString From
      // -------------------------------------------------
      const _updateQueryString = function(_clearQueryString, _updateQueryString, _this) {
        if (updateQueryString) {
          queryString.Remove(_clearQueryString)
          queryString.Update(_updateQueryString, _this.siblings('input').val())
          return null
        } else {
          return false
        }
      }
      // -------------------------------------------------
      const $csElem = parentSel.find('.custom-select-duration')
      const $csTitle = parentSel.find('.custom-select-duration .section-title')
      const csDurationRadios = function(typeDuration) {
        let obj = {}
        if (typeDuration === 'DurationInterval') {
          obj = {
            idEqClicked: '0',
            idEqClear: '1',
            updateQueryString: 'DurationInterval',
            clearQueryString: 'DurationDays',
          }
        } else if (typeDuration === 'DurationDays') {
          obj = {
            idEqClicked: '1',
            idEqClear: '0',
            updateQueryString: 'DurationDays',
            clearQueryString: 'DurationInterval',
          }
        }

        FORMS.helpers.csRadiosList.radioLabel(`.form-group:eq(${obj.idEqClicked})`, $csElem).find('label').on('click', function() {

          // -----------------------------------------------------------
          // Update section-title
          FORMS.helpers.csRadiosList.onChange($(this), $csTitle)

          // -----------------------------------------------------------
          // Update query string
          FORMS.helpers.updateQueryString(
            _updateQueryString(obj.clearQueryString, obj.updateQueryString, $(this))
          )

          // -----------------------------------------------------------
          // Resest checked radio input
          FORMS.helpers.csRadiosList.radioLabel('.form-group', $csElem).find('input[type="radio"]').each(function() {
            $(this).attr('checked', false)
            if ($(this).hasClass('checked')) {
              $(this).removeClass('checked')
            }
          })

          // -----------------------------------------------------------
          // Remove checked value from siblings radio list
          FORMS.helpers.csRadiosList.radioLabel(`.form-group:eq(${obj.idEqClear})`, $csElem).find('input[type="radio"]').each(function() {
            $(this).attr('checked', false)
            if ($(this).hasClass('checked')) {
              $(this).removeClass('checked')
            }
          })
          // -----------------------------------------------------------
          // Get value from checked input and return it values to public function
          const inputValue = $(this).prev().val()

          callback && callback(inputValue)
        })
      }

      // List of radio DurationInterval
      csDurationRadios('DurationInterval')

      // List of radio DurationDays
      csDurationRadios('DurationDays')
    },

    /**
     * @name pricePerson
     * @param  {Object} settings has params:
     * => {Object} parentSel - set object selector in jQuery
     * => {Boolean} priceRangeSlider - if true do actions for price range slider
     * => {Boolean} updateQueryString - if ture update query string
     * => {Object} valuePrice - object has value price: min and max
     * => {Function} callback - do anything on change value radio input
     * @return undefined
     */
    pricePerson (settings) {
      const parentSel = settings.parentSel
      const priceRangeSlider = false || settings.priceRangeSlider
      const updateQueryString = false || settings.updateQueryString
      const valuesPriceRange = {} || settings.valuesPriceRange
      const callback = false || settings.callback

      // -------------------------------------------------
      // Update queryString From
      // -------------------------------------------------
      const _updateQueryString = function(_valuePrice) {
        if (updateQueryString) {
          queryString.Update('PriceFrom', _valuePrice.From)
          queryString.Update('PriceTo', _valuePrice.To)
          return null
        } else {
          return false
        }
      }
      const $csPricePersonElement = parentSel.find('.custom-select-price-person')
      const $csPricePersonTitle = parentSel.find('.custom-select-price-person .section-title')

      //$csPricePerson_psElem.perfectScrollbar();

      FORMS.helpers.csRadiosList.radioLabel('.form-group', $csPricePersonElement).find('label').on('click', function() {
        FORMS.helpers.csRadiosList.onChange($(this), $csPricePersonTitle)
        // -------------------------------------------------------------
        // Get value from radio
        // -------------------------------------------------------------
        const inputValue = $(this).prev().val()

        // -------------------------------------------------------------
        // Set value for Price Range Slider
        // -------------------------------------------------------------
        if (priceRangeSlider) {
          const valuePrice = {
            From: FORMS.helpers.getRangeValues(inputValue, 'From'),
            To: FORMS.helpers.getRangeValues(inputValue, 'To'),
          }
          const $csPriceRangeSlider = $('.custom-select-price-range__slider')
          const $csPriceRangeTooltip = $('.custom-select-price-range__tooltip')
          const $csPriceRangeInput = $('.custom-select-price-range').find('.form-control')
          const priceRangeType = 'man'

          // ValuesPriceRange is always undefined - temporary fix
          if (valuesPriceRange.min == undefined) {
            valuesPriceRange.min = 0
            valuesPriceRange.max = 50000
          }
          if (valuePrice.To == valuesPriceRange.min) {
            valuePrice.To = valuesPriceRange.max
          }

          // -----------------------------------------------------------
          // Update values in range slider
          $csPriceRangeSlider.slider('option', 'values', [ valuePrice.From, valuePrice.To ])
          $csPriceRangeInput.val(`${valuePrice.From}:${valuePrice.To};${priceRangeType}`)

          // -----------------------------------------------------------
          // Update values in tooltip of range slider
          $csPriceRangeTooltip.find('.price-value__value').text(valuePrice.To)

          // -----------------------------------------------------------
          // Update query string
          FORMS.helpers.updateQueryString(
            _updateQueryString(valuePrice)
          )
        }

        FORMS.helpers.csRadiosList.radioLabel('.form-group', $csPricePersonElement).find('input[type="radio"]').each(function() {
          $(this).attr('checked', false)
          if ($(this).hasClass('checked')) {
            $(this).removeClass('checked')
          }
        })
        // -------------------------------------------------------------
        // Get value from checked input and return it values to public function
        // -------------------------------------------------------------
        callback && callback(inputValue)

      })
    },

    /**
     * @name [room description]
     * @param  {Object} parentSel - set object selector in jQuery
     * @param  {Function} callback - do anything on change value radio input
     * @return undefined
     */
    room (parentSel, callback) {
      const $csElem = parentSel.find('.custom-select-room')
      const $csElemTitle = parentSel.find('.custom-select-room .section-title')

      FORMS.helpers.csRadiosList.radioLabel('.form-group', $csElem).find('label').on('click', function() {
        FORMS.helpers.csRadiosList.onChange($(this), $csElemTitle)
        // -----------------------------------------------------------------
        // Get value from radio
        // -----------------------------------------------------------------
        const inputValue = $(this).prev().val()

        FORMS.helpers.csRadiosList.radioLabel('.form-group', $csElem).find('input[type="radio"]').each(function() {
          $(this).attr('checked', false)
          if ($(this).hasClass('checked')) {
            $(this).removeClass('checked')
          }
        })

        // -----------------------------------------------------------------
        // Get value from checked input and return it values to public function
        // -----------------------------------------------------------------
        callback && callback(inputValue)
      })
    },

    /**
     * @name [food description]
     * @param  {Object} parentSel - set object selector in jQuery
     * @param  {Function} callback - do anything on change value radio input
     * @return undefined
     */
    food (parentSel, callback) {
      const $csElem = parentSel.find('.custom-select-food')
      const $csElemTitle = parentSel.find('.custom-select-food .section-title')

      FORMS.helpers.csRadiosList.radioLabel('.form-group', $csElem).find('label').on('click', function() {
        FORMS.helpers.csRadiosList.onChange($(this), $csElemTitle)
        // -----------------------------------------------------------------
        // Get value from radio
        // -----------------------------------------------------------------
        const inputValue = $(this).prev().val()

        FORMS.helpers.csRadiosList.radioLabel('.form-group', $csElem).find('input[type="radio"]').each(function() {
          $(this).attr('checked', false)
          if ($(this).hasClass('checked')) {
            $(this).removeClass('checked')
          }
        })

        // -----------------------------------------------------------------
        // Get value from checked input and return it values to public function
        // -----------------------------------------------------------------
        callback && callback(inputValue)
      })
    },

    /**
     * @name [people description]
     * @method
     * @type {Object}
     */
    people: {
      /**
       * [clearValues description]
       * @param  {Object} parentSel       [description]
       * @param  {Object} objCounter      [description]
       * @param  {Number} counterAdults   [description]
       * @param  {Number} counterChildren [description]
       * @return undefined                 [description]
       */
      clearValues (parentSel, objCounter, counterAdults, counterChildren) {
        const csPeopleBindElement = parentSel.find('.custom-select-people .form-group label + div')
        const $csPeopleBindSelAdults = csPeopleBindElement.eq(0) // Id selector of adults
        const $csPeopleBindSelChildren = csPeopleBindElement.eq(1) // Id selector of chaldren
        const $csPeopleInputAdults = $csPeopleBindSelAdults.find('input')
        const $csPeopleInputChildren = $csPeopleBindSelChildren.find('input')

        const $csPeopleClearRemove = parentSel.find('.custom-select-people .dropdown-menu >.form-group +.form-group .remove-item')
        const $csPeopleClearAdd = parentSel.find('.custom-select-people .dropdown-menu >.form-group +.form-group .add-item')
        const $csPeopleChildList = parentSel.find('.custom-select-people .dropdown-menu .dropdown-menu__inner .form-group')
        // -------------------------------------------------
        // Update queryString Children & Adults
        // -------------------------------------------------
        queryString.Remove('Adults')
        queryString.Remove('Children')

        for (let i = 1; i <= counterChildren; i++) {
          queryString.Remove(`Child${i}`)
        }

        objCounter.Adults = 2
        objCounter.Children = 0
        counterAdults = 2
        counterChildren = 0

        $csPeopleInputAdults.val(counterAdults)
        $csPeopleInputChildren.val(counterChildren)

        // TODO: add clear values for fields of birthday children
        //$(this).closest('.custom-select-people').find('.form-group').slice(2)
        //    .hide()
        //    .find('input.form-control').val('');

        $csPeopleChildList.hide()
        $csPeopleClearRemove.hide()
        $csPeopleClearAdd.show()

        FORMS.customSelect.people.updateLabel(
          parentSel,
          counterAdults,
          counterChildren
        )

        $(this).closest('.custom-select-people').find('.add-item').show()
      },
      /**
       * [changeValuesRange description]
       * @param  {Object} parentSel       [description]
       * @param  {Object} objValuesRanges [description]
       * @return undefined                 [description]
       */
      changeValuesRange (parentSel, objValuesRanges) {
        const bookingFormElem = parentSel
        const csPeopleElem = bookingFormElem.find('.custom-select-people .form-group label + div')
        const csPeopleElemAdultsInput = csPeopleElem.eq(0).find('input')
        const csPeopleElemChildrenInput = csPeopleElem.eq(1).find('input')
        const csPeopleAddItemClass = '.add-item'

        csPeopleElemAdultsInput
          .attr('data-val-range-max', objValuesRanges.adults.max).attr('data-val-range-min', objValuesRanges.adults.min)

        csPeopleElemChildrenInput
          .attr('data-val-range-max', objValuesRanges.children.max).attr('data-val-range-min', objValuesRanges.children.min)

        if (csPeopleElemAdultsInput.val() < objValuesRanges.adults.max) {
          csPeopleElemAdultsInput.next(csPeopleAddItemClass).show()
        }
        if (csPeopleElemAdultsInput.val() == objValuesRanges.adults.max ||
                    csPeopleElemAdultsInput.val() == objValuesRanges.adults.min) {
          csPeopleElemAdultsInput.next(csPeopleAddItemClass).hide()
        }

        if (csPeopleElemChildrenInput.val() < objValuesRanges.children.max) {
          csPeopleElemChildrenInput.next(csPeopleAddItemClass).show()
        }
        if (csPeopleElemChildrenInput.val() == objValuesRanges.children.max ||
                    csPeopleElemChildrenInput.val() == objValuesRanges.children.min) {
          csPeopleElemChildrenInput.next(csPeopleAddItemClass).hide()
        }

      },

      /**
       * @name updateLabel - Update text in .section-title]
       * @param  {Object} parentSel   [description]
       * @param  {Number} valAdults   [description]
       * @param  {Number} valChildren [description]
       * @return undefined            [description]
       */
      updateLabel (parentSel, valAdults, valChildren) {
        const $csPeopleTitle = parentSel.find('.custom-select-people > .section-title')

        $csPeopleTitle.html(
          `${EXPRESSIONS_DICTIONARY.titleAdults} ${valAdults 
          } / ${
            EXPRESSIONS_DICTIONARY.titleChildren} ${valChildren}`
        )
      },

      /**
       * @name showBirthdayField
       * @param  {Object} startIndexBirthdayField [description]
       * @param  {Number} index                   [description]
       * @param  {Boolean} changeQueryString       [description]
       * @param  {Function} onCallbackChildBirthday [description]
       * @return undefined
       */
      showBirthdayField (startIndexBirthdayField, index, changeQueryString, onCallbackChildBirthday) {
        //Log.debug(index);

        const todayDate = moment().endOf('day').toDate()
        const minDateChild = moment().subtract(18, 'years').startOf('day').toDate()

        $(startIndexBirthdayField.eq(index)).find('input.form-control').datetimepicker({
          viewMode: 'years',
          useCurrent: false,
          format: 'DD.MM.YYYY',
          extraFormats: [ 'DD.MM.YYYY', 'DD.MM.Y', 'YYYYMMDD' ],
          keepOpen: true,
          showClose: true,
          minDate: minDateChild,
          maxDate: todayDate,
          icons: {
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            close: 'custom-icon--cross',
          },
          'toolbarPlacement': 'top',
        }).on('dp.show', function() {
          if ($('.datepicker-title').length === 0) {
            $('.bootstrap-datetimepicker-widget').prepend(`<div class="datepicker-title">${EXPRESSIONS_DICTIONARY.chooseBirthday}</div>`)
          }
        }).on('dp.change', function(e) {
          // -------------------------------------------------
          // Update queryString Children Age
          // -------------------------------------------------
          const parsedDateChild = moment(e.date._d).format('YYYYMMDD')
          const ChildIndex = `Child${index + 1}`

          onCallbackChildBirthday && onCallbackChildBirthday({ index: ChildIndex, dateBirthday: parsedDateChild })

          if (changeQueryString) {
            queryString.Update(ChildIndex, parsedDateChild)
          }
          // -------------------------------------------------
        })
      },

      /**
       * [changeAmount description]
       * @param  {Object} parentSel               [description]
       * @param  {Boolean} updateQueryString       [description]
       * @param  {Function} onCallback              [description]
       * @param  {Function} onCallbackChildBirthday [description]
       * @param  {Object} objCounter              [description]
       * @return undefined                         [description]
       */
      changeAmount (parentSel, updateQueryString, onCallback, onCallbackChildBirthday, objCounter) {
        let _updateQueryStringChildBirthday = null
        if (SELECTOR.MAIN_SEARCH.exists()) {
          _updateQueryStringChildBirthday = true
        } else {
          _updateQueryStringChildBirthday = false
        }

        const _updateQueryString = function(queryStringParam, count) {
          if (updateQueryString) {
            _updateQueryStringChildBirthday = true
            queryString.Update(queryStringParam, count)
            return null
          } else {
            _updateQueryStringChildBirthday = false
            return false
          }
        }

        const csPeopleBindElement = parentSel.find('.custom-select-people .form-group label + div')
        const $csPeopleBindSelAdults = csPeopleBindElement.eq(0) // Id selector of adults
        const $csPeopleBindSelChildren = csPeopleBindElement.eq(1) // Id selector of chaldren
        const $csPeopleInputAdults = $csPeopleBindSelAdults.find('input')
        const $csPeopleInputChildren = $csPeopleBindSelChildren.find('input')
        const csPeopleRemoveItem = 'remove-item'
        const csPeopleRemoveItemClass = `.${csPeopleRemoveItem}`
        const csPeopleAddItem = 'add-item'
        const csPeopleAddItemClass = `.${csPeopleAddItem}`
        const startIndexBirthdayField = parentSel.find('.custom-select-people .dropdown-menu__inner .form-group')

        $csPeopleInputAdults.val(objCounter.Adults)
        $csPeopleInputChildren.val(objCounter.Children)

        let counterAdults = $csPeopleInputAdults.val()
        let counterChildren = $csPeopleInputChildren.val()

        const valsRangesAdults = {
          min: $csPeopleInputAdults.attr('data-val-range-min'),
          max: $csPeopleInputAdults.attr('data-val-range-max'),
        }
        const valsRangesChildren = {
          min: $csPeopleInputChildren.attr('data-val-range-min'),
          max: $csPeopleInputChildren.attr('data-val-range-max'),
        }
        const $csPeopleDropdownElem = parentSel.find('.custom-select-people .dropdown-menu')

        //Log.debug('counterAdults:', valsRangesAdults, 'counterChildren:', valsRangesChildren)
        //log.debug('counterAdults:', counterAdults, 'counterChildren:', counterChildren)
        // Set dropdown-menu height
        updateDropdownHeight(valsRangesChildren.max)

        // Set default label with amount of people
        FORMS.customSelect.people.updateLabel(
          parentSel,
          counterAdults,
          counterChildren
        )

        // Show fields of birthday children
        for (let i = 1; i <= 6; i++) {
          if (counterChildren >= i) {
            toggleBirthdayField(i, 'show')
          } else {
            toggleBirthdayField(i - 1, 'hide')
          }
        }

        // Init perfectScrollbar
        //csPeople_psElem.perfectScrollbar();

        // -------------------------------------------------------------
        // Change count of children
        // -------------------------------------------------------------
        if (counterChildren == valsRangesChildren.min) {
          $csPeopleBindSelChildren.find(csPeopleRemoveItemClass).hide()
        } else {
          $csPeopleBindSelChildren.find(csPeopleRemoveItemClass).show()
        }
        if (counterChildren == valsRangesChildren.max) {
          $csPeopleBindSelChildren.find(csPeopleAddItemClass).hide()
        } else {
          $csPeopleBindSelChildren.find(csPeopleAddItemClass).show()
        }

        if (!$csPeopleBindSelChildren.hasClass('initialized')) {
          $csPeopleBindSelChildren.addClass('initialized')

          $csPeopleBindSelChildren
            .on('click', csPeopleAddItemClass, function(e) {
              let counterChildren = $csPeopleInputChildren.val()

              if (counterChildren >= valsRangesChildren.min) {
                counterChildren++
              }
              if (counterChildren == valsRangesChildren.min) {
                $(this).hide()
              }
              if (counterChildren < valsRangesChildren.max) {
                $(this).siblings(csPeopleRemoveItemClass).show()
              }
              if (counterChildren == valsRangesChildren.max) {
                $(this).hide()
                $(this).siblings(csPeopleRemoveItemClass).show()
              }

              // -------------------------------------------------------
              // Update value
              changeValOfPeople.add(e, $(this), counterChildren, 'Children', toggleBirthdayField)

              for (let i = 1; i <= counterChildren; i++) {
                const elementName = `Child${i}`
                let date = $csPeopleDropdownElem.find(`#${elementName}`).val()
                if (!date) {
                  date = moment(new Date()).format('DD.MM.YYYY')
                }
                const childDate = moment(date, [ 'DD.MM.YYYY' ]).format('YYYYMMDD')

                changeValOfPeople.add(e, null, childDate, elementName, null)
              }

              // -------------------------------------------------------
              // Update text in .section-title
              FORMS.customSelect.people.updateLabel(
                parentSel,
                $csPeopleInputAdults.val(),
                counterChildren
              )

            })
            .on('click', csPeopleRemoveItemClass, function(e) {
              let counterChildren = $csPeopleInputChildren.val()

              if (counterChildren > valsRangesChildren.min) {
                counterChildren--
              }
              if (counterChildren == valsRangesChildren.min) {
                $(this).hide()
              }
              if (counterChildren < valsRangesChildren.max) {
                $(this).siblings(csPeopleAddItemClass).show()
              }
              if (counterChildren == valsRangesChildren.max) {
                $(this).hide()
                $(this).siblings(csPeopleAddItemClass).show()
              }

              // -------------------------------------------------------
              // Show/Hide fields of birthday children
              queryString.Remove(`Child${parseFloat(counterChildren) + 1}`)

              //$(this).closest('.custom-select-people').slice(2).eq(counterChildren).find('input.form-control').val('');

              // -------------------------------------------------------
              // Update value
              changeValOfPeople.remove(e, $(this), counterChildren, 'Children', toggleBirthdayField)

              // -------------------------------------------------------
              // Update text in .section-title
              FORMS.customSelect.people.updateLabel(
                parentSel,
                $csPeopleInputAdults.val(),
                counterChildren
              )
            })
        }

        // -------------------------------------------------------------
        // Change count of adults
        // -------------------------------------------------------------
        if (counterAdults == valsRangesAdults.min) {
          $csPeopleBindSelAdults.find(csPeopleRemoveItemClass).hide()
        }
        if (counterAdults == valsRangesAdults.max) {
          $csPeopleBindSelAdults.find(csPeopleAddItemClass).hide()
        }

        if (!$csPeopleBindSelAdults.hasClass('initialized')) {
          $csPeopleBindSelAdults.addClass('initialized')
          $csPeopleBindSelAdults
            .on('click', csPeopleAddItemClass, function(e) {
              let counterAdults = $csPeopleInputAdults.val()
              if (counterAdults >= valsRangesAdults.min) {
                counterAdults++
              }
              if (counterAdults == valsRangesAdults.min || counterAdults == valsRangesAdults.max) {
                $(this).hide()
              }
              if (counterAdults <= valsRangesAdults.max) {
                $(this).siblings(csPeopleRemoveItemClass).show()
              }

              // Update value
              changeValOfPeople.add(e, $(this), counterAdults, 'Adults')

              // Update text in .section-title
              FORMS.customSelect.people.updateLabel(
                parentSel,
                counterAdults,
                $csPeopleInputChildren.val()
              )
            })
            .on('click', csPeopleRemoveItemClass, function(e) {
              let counterAdults = $csPeopleInputAdults.val()
              if (counterAdults > valsRangesAdults.min) {
                counterAdults--
              }
              if (counterAdults == valsRangesAdults.min || counterAdults == valsRangesAdults.max) {
                $(this).hide()
              }
              if (counterAdults <= valsRangesAdults.max) {
                $(this).siblings(csPeopleAddItemClass).show()
              }

              // Update value
              changeValOfPeople.remove(e, $(this), counterAdults, 'Adults')

              // Update text in .section-title
              FORMS.customSelect.people.updateLabel(
                parentSel,
                counterAdults,
                $csPeopleInputChildren.val()
              )
            })
        }

        // -----------------------------------------------------------------
        // Clear all values
        // -----------------------------------------------------------------
        parentSel.find('.custom-select-people .btn-clear').on('click', function() {
          FORMS.customSelect.people.clearValues(parentSel, objCounter, counterAdults, counterChildren)
          counterChildren = 0
          counterAdults = 2
          // -------------------------------------------------
          //updatePerfectScrollbar();
        })

        // -------------------------------------------------------------
        // Method for change count of people
        // -------------------------------------------------------------
        const changeValOfPeople = {
          add (e, _this, count, queryStringParam, toggleBirthdayField) {
            //Log.debug('count', count);
            e.preventDefault()

            _this && _this.siblings('input').val(count)

            // -------------------------------------------------
            // Update queryString Children & Adults
            // -------------------------------------------------
            _updateQueryString(queryStringParam, count)

            // -------------------------------------------------
            // toggle for show or hide Birthday Fields
            // -------------------------------------------------
            toggleBirthdayField && toggleBirthdayField(count, 'show')

            onCallback && onCallback(queryStringParam, count, e)
          },
          remove (e, _this, count, queryStringParam, toggleBirthdayField) {
            //Log.debug('count', count);
            e.preventDefault()

            _this.siblings('input').val(count)

            // -------------------------------------------------
            // Update queryString Children & Adults
            // -------------------------------------------------
            _updateQueryString(queryStringParam, count)

            // -------------------------------------------------
            // toggle for show or hide Birthday Fields
            // -------------------------------------------------
            toggleBirthdayField && toggleBirthdayField(count, 'hide')

            onCallback && onCallback(queryStringParam, count, e)
          },
        }

        // -------------------------------------------------------------
        // Show/hide on change value by button
        // -------------------------------------------------------------
        function toggleBirthdayField (index, showOrHide) {
          //Log.debug('showBirthdayField');
          if (showOrHide == 'show') {
            const _index = (index - 1)
            //Log.debug('show:eq', _index);
            startIndexBirthdayField.eq(_index).fadeIn()

            FORMS.customSelect.people.showBirthdayField(
              startIndexBirthdayField,
              _index,
              _updateQueryStringChildBirthday,
              onCallbackChildBirthday
            )

            //UpdatePerfectScrollbar(index-1);
            //updateDropdownHeight(index-1);
          } else if (showOrHide == 'hide') {
            //Log.debug('hide:eq', i);
            startIndexBirthdayField.eq(index).fadeOut()

            //UpdatePerfectScrollbar(index-2);
            //updateDropdownHeight(index-2);
          }
        }

        // -------------------------------------------------------------
        // Update height dropdown
        // -------------------------------------------------------------
        function updateDropdownHeight (index) {
          const csPeopleItemChildrenHeight = 75
          const csPeopleDropdownHeight = 450
          
          const csPeopleMaxHeight = csPeopleDropdownHeight + (csPeopleItemChildrenHeight * index)
          $csPeopleDropdownElem.css('max-height', csPeopleMaxHeight)
        }
      },

      /**
       * @name [people init description]
       * @param  {Object} parentSel - set object selector in jQuery
       * @param  {Boolean} updateQueryString - if ture update query string
       * @param  {Function} onCallback - do anything on change value radio input
       * @param  {Function} onCallbackChildBirthday -
       * @return undefined
       */
      init (parentSel, updateQueryString, onCallback, onCallbackChildBirthday) {
        let lastParentSel = parentSel
        if (parentSel.length > 1) {
          lastParentSel = parentSel.slice(parentSel.length - 1, parentSel.length)
        }

        const csPeopleBindElement = lastParentSel.find('.custom-select-people .form-group label + div')
        const csPeopleWrapAllDatesChildren = function(parentElem) {
          const element = parentElem.find('.custom-select-people .form-group')
          return element
        }
        const csPeopleBuildNavChangePeople = function(_this) {
          const insertWhere = _this.find('label + div input')
          $(`<span role="button" class="${csPeopleRemoveItem}">-</span>`).insertBefore(insertWhere)
          $(`<span role="button" class="${csPeopleAddItem}">+</span>`).insertAfter(insertWhere)
        }
        const $csPeopleBindSelAdults = csPeopleBindElement.eq(0)
        const $csPeopleBindSelChildren = csPeopleBindElement.eq(1)
        const $csPeopleInputAdults = $csPeopleBindSelAdults.find('input')
        const $csPeopleInputChildren = $csPeopleBindSelChildren.find('input')
        const csPeopleRemoveItem = 'remove-item'
        const csPeopleAddItem = 'add-item'

        // Build nav for changing values of people
        csPeopleBuildNavChangePeople(csPeopleWrapAllDatesChildren(lastParentSel).slice(0, 2))

        // Wrap all fields of birthday children
        csPeopleWrapAllDatesChildren(lastParentSel).slice(2).hide().wrapAll('<div class="dropdown-menu__inner" />')

        const $csPeopleDropdownElement = lastParentSel.find('.custom-select-people .dropdown-menu')

        $csPeopleDropdownElement.prepend('<div class="custom-select-people__close">×</div>')
        $csPeopleDropdownElement.prepend('<div class="custom-select-people__msg" />')

        const runChildrenBirthdayValidator = e => {
          const form = e.target ? e.target.closest('form') : e.closest('form')
          const childrenBirthdayValidator = new ChildrenBirthdayValidator(form)
          
          if (childrenBirthdayValidator.isAtLeastOneDateDefault()) {
            childrenBirthdayValidator.initValidationModal()
          }
        }

        $('.custom-select-people__close').click(function(e) {
          e.stopPropagation()
          $('.custom-select-people').removeClass('open')
          $('.offer-sidebar .custom-select-people').trigger('popup:closed')
          runChildrenBirthdayValidator(e)
        })

        if (!$('.offer-sidebar .custom-select-people').hasClass('initialize-trigger')) {
          $('.offer-sidebar .custom-select-people').addClass('initialize-trigger')
          $('.offer-sidebar .custom-select-people').on('hide.bs.dropdown', function() {
            $(this).trigger('popup:closed')
          })
        }

        const selectPeopleMutatedClass = mutation => mutation.attributeName === 'class'
        const selectPeopleHadOpenClass = mutation => mutation.oldValue.indexOf('open') !== -1
        const classMutationRequirement = mutation => selectPeopleMutatedClass(mutation) && selectPeopleHadOpenClass(mutation)

        const lookForSelectPeopleMutations = target => {
          const config = { attributes: true, attributeOldValue: true }
          const type = 'attributes'

          new Observer(target, config, type).observe(mutation => 
            classMutationRequirement(mutation) ? runChildrenBirthdayValidator(target) : false
          )
        }
        document.querySelectorAll('.custom-select-people').forEach(elem => lookForSelectPeopleMutations(elem))

        // Build button to clear all val concerns people in dropdown
        $csPeopleDropdownElement.append(`<div class="btn-clear"><span role="button"><i class="custom-icon--cross"></i>${EXPRESSIONS_DICTIONARY.clearAll}</span></div>`)

        $csPeopleInputAdults.attr('readonly', 'readonly')
        $csPeopleInputChildren.attr('readonly', 'readonly')

        const objCounter = {
          Adults: $csPeopleInputAdults.val(),
          Children: $csPeopleInputChildren.val(),
        }

        FORMS.customSelect.people.changeAmount(
          lastParentSel,
          updateQueryString,
          onCallback,
          onCallbackChildBirthday,
          objCounter
        )

      },
    },

  },
}

module.exports = FORMS




// WEBPACK FOOTER //
// ./src/modules/forms.js